//

export const DOCUMENTOS_GET_DOCUMENTACION = "documentos/GET_DOCUMENTACION"
export const DOCUMENTOS_GET_DOCUMENTACION_SUCCESS =
  "documentos/GET_DOCUMENTACION_SUCCESS"
export const DOCUMENTOS_GET_DOCUMENTACION_FAIL =
  "documentos/GET_DOCUMENTACION_FAIL"

export const DOCUMENTOS_GET_DOCUMENTO = "documentos/GET_DOCUMENTO"
export const DOCUMENTOS_GET_DOCUMENTO_SUCCESS =
  "documentos/GET_DOCUMENTO_SUCCESS"
export const DOCUMENTOS_GET_DOCUMENTO_FAIL = "documentos/GET_DOCUMENTO_FAIL"

export const DOCUMENTOS_SET_IDRELPERDOC = "documentos/SET_IDRELPERDOC"
export const DOCUMENTOS_UNSET_REFRESH = "documentos/UNSET_REFRESH"
export const DOCUMENTOS_UNSET_NOTIFICACION = "documentos/UNSET_NOTIFICACION"

export const DOCUMENTOS_ADD_DOCUMENTO = "documentos/ADD_DOCUMENTO"
export const DOCUMENTOS_ADD_DOCUMENTO_SUCCESS =
  "documentos/ADD_DOCUMENTO_SUCCESS"
export const DOCUMENTOS_ADD_DOCUMENTO_FAIL = "documentos/ADD_DOCUMENTO_FAIL"

export const DOCUMENTOS_UPDATE_DOCUMENTO = "documentos/UPDATE_DOCUMENTO"
export const DOCUMENTOS_UPDATE_DOCUMENTO_SUCCESS =
  "documentos/UPDATE_DOCUMENTO_SUCCESS"
export const DOCUMENTOS_UPDATE_DOCUMENTO_FAIL =
  "documentos/UPDATE_DOCUMENTO_FAIL"

export const DOCUMENTOS_DEL_DOCUMENTO = "documentos/DEL_DOCUMENTO"
export const DOCUMENTOS_DEL_DOCUMENTO_SUCCESS =
  "documentos/DEL_DOCUMENTO_SUCCESS"
export const DOCUMENTOS_DEL_DOCUMENTO_FAIL = "documentos/DEL_DOCUMENTO_FAIL"

export const DOCUMENTOS_UPDATE_LISTADOCUMENTOS =
  "documentos/UPDATE_LISTADOCUMENTOS"
export const DOCUMENTOS_UPDATE_LISTADOCUMENTOS_SUCCESS =
  "documentos/UPDATE_LISTADOCUMENTOS_SUCCESS"
export const DOCUMENTOS_UPDATE_LISTADOCUMENTOS_FAIL =
  "documentos/UPDATE_LISTADOCUMENTOS_FAIL"

export const DOCUMENTOS_UPLOAD_FILE = "documentos/UPLOAD_FILE"
export const DOCUMENTOS_UPLOAD_FILE_SUCCESS = "documentos/UPLOAD_FILE_SUCCESS"
export const DOCUMENTOS_UPLOAD_FILE_FAIL = "documentos/UPLOAD_FILE_FAIL"
